import { CertificateGenerationDocumentId } from '~/store/covenants/types.ts';

const GENERATABLE_DOCUMENT_IDS = new Set<string>(Object.values(CertificateGenerationDocumentId));

export const isDocumentGenerationAvailable = (
  documentId: string | number,
  isNewApplication: boolean,
  isFeatureEnabled: boolean
): boolean =>
  isNewApplication && isFeatureEnabled && GENERATABLE_DOCUMENT_IDS.has(String(documentId));
